import { RootState } from '@/store/types';
import { MutationTree, ActionTree, GetterTree } from 'vuex';
import { Module, ActionContext } from 'vuex';
import { searchByPS } from '@/services/api/searchVaccinations/api';
import { DossierRechercheType, SearchResult } from '@/store/folder/SearchResult';
import { SearchByPsRequest } from '@/services/api/searchVaccinations/types';
import _ from 'lodash';
import { formatDateISO } from '@/services/dateFormatter';
import dayjs from 'dayjs';

const namespaced: boolean = true;
const today: string = formatDateISO(dayjs());

export interface VaccinationsState {
	dossiers: DossierRechercheType[];
	criteresRecherche: SearchByPsRequest;
	isError: boolean;
	codeErreur: string;
}

export const state: VaccinationsState = {
	dossiers: [],
	criteresRecherche: {
		nir: '',
		nonAssureFranceOnly: false,
		debutEnregistrement: today,
		finEnregistrement: today,
		etapes: ['Eligibilité', '1ère vaccination']
	},
	isError: false,
	codeErreur: ''
};

const mutations: MutationTree<VaccinationsState> = {
	setDossiers(state: VaccinationsState, dossiers: DossierRechercheType[]) {
		state.dossiers = dossiers;
	},
	setIsError(state: VaccinationsState, isError: boolean) {
		state.isError = isError;
	},
	setCodeError(state: VaccinationsState, codeErreur: string) {
		state.codeErreur = codeErreur;
	},
	setCriteresRecherche(state: VaccinationsState, criteres: SearchByPsRequest) {
		state.criteresRecherche = criteres;
	},
	cleanRechercheDossiers(state: VaccinationsState) {
		state.dossiers = [];
		state.isError = false;
		state.codeErreur = '';
		state.criteresRecherche = {
			nir: '',
			nonAssureFranceOnly: false,
			debutEnregistrement: today,
			finEnregistrement: today,
			etapes: ['Eligibilité', '1ère vaccination']
		};
	}
};
const actions: ActionTree<VaccinationsState, RootState> = {
	async loadMesVaccinations(
		context: ActionContext<VaccinationsState, RootState>,
		request: SearchByPsRequest
	) {
		context.commit('cleanRechercheDossiers');
		context.commit('setCriteresRecherche', _.cloneDeep(request));
		return searchByPS(request)
			.then((result) => {
				const reponse: SearchResult = _.get(result, 'data.value');
				const codeErreur: string = _.get(reponse, 'errorCode');
				context.commit('setDossiers', _.get(reponse, 'dossiers'));
				context.commit('setCodeError', codeErreur);
				context.commit('setIsError', !_.isEmpty(codeErreur));
			}).catch(() => {
				context.commit('setIsError', true);
			});
	},
	cleanRechercheDossiers(context: ActionContext<VaccinationsState, RootState>) {
		context.commit('cleanRechercheDossiers');
	}
};
const getters: GetterTree<VaccinationsState, RootState> = {
	getDossiers(state: VaccinationsState): DossierRechercheType[] | undefined {
		return state.dossiers;
	},

	getCriteresRecherche(state: VaccinationsState): SearchByPsRequest {
		return state.criteresRecherche;
	},

	getIsError(state: VaccinationsState): boolean {
		return state.isError;
	},

	getCodeError(state: VaccinationsState): string {
		return state.codeErreur;
	}
};
export const vaccinations: Module<VaccinationsState, RootState> = {
	namespaced,
	state,
	actions,
	getters,
	mutations
};
